/* India Living theme JS — no dependencies, three jobs: reveals, cart drawer, small UI. */
(function () {
  // Scroll reveals. Content is ALWAYS in the DOM; we only fade it in. Reduced motion is
  // handled in CSS (the .rv class never hides content there).
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -8% 0px' });
  document.querySelectorAll('.rv').forEach(function (el) { io.observe(el); });

  // Cart drawer
  var body = document.body;
  var drawer = document.querySelector('.drawer');
  var lastFocus;
  function openDrawer() { lastFocus = document.activeElement; drawer.inert = false; body.classList.add('drawer-open'); drawer.querySelector('[data-close-cart]').focus(); }
  function closeDrawer() { body.classList.remove('drawer-open'); drawer.inert = true; if (lastFocus) lastFocus.focus(); }
  document.addEventListener('click', function (ev) {
    if (ev.target.closest('[data-open-cart]')) { ev.preventDefault(); refreshCart().then(openDrawer).catch(cartError); }
    if (ev.target.closest('[data-close-cart]') || ev.target.classList.contains('scrim')) closeDrawer();
    var rm = ev.target.closest('[data-remove-line]');
    if (rm) { ev.preventDefault(); rm.disabled = true; changeLine(rm.getAttribute('data-remove-line'), 0).catch(function () { rm.disabled = false; cartError(); }); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
  function checked(r) { if (!r.ok) throw new Error('Cart request failed'); return r.json(); }
  function escapeHTML(value) { return String(value || '').replace(/[&<>"']/g, function(c) { return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); }
  function cartError() {
    var notice = drawer.querySelector('[data-cart-error]');
    if (!notice) { notice = document.createElement('p'); notice.dataset.cartError = ''; notice.setAttribute('role','alert'); drawer.querySelector('.drawer__foot').prepend(notice); }
    notice.textContent = 'We could not update your cart. Please try again.';
    if (!body.classList.contains('drawer-open')) openDrawer();
  }
  document.addEventListener('cart:updated', function(event) { renderCart(event.detail); });
  document.addEventListener('cart:refresh', function() { refreshCart().catch(cartError); });
  document.addEventListener('keydown', function(event) {
    if (event.key !== 'Tab' || !body.classList.contains('drawer-open')) return;
    var controls = Array.from(drawer.querySelectorAll('a[href],button:not(:disabled),input,select,textarea,summary')).filter(function(el) { return el.getClientRects().length; });
    var first = controls[0], last = controls[controls.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });
  function money(cents, cur) {
    try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: cur }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2); }
  }

  function renderCart(cart) {
    var el = document.querySelector('[data-cart-items]'); if (!el) return;
    var cur = cart.currency || 'USD';
    el.innerHTML = cart.items.length ? cart.items.map(function (i) {
      var picture = i.image ? '<img src="' + escapeHTML(i.image + (i.image.indexOf('?') >= 0 ? '&' : '?') + 'width=128') + '" alt="" loading="lazy">' : '<span class="purchase-item-placeholder" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor"><path d="M5 7h14l1 14H4L5 7Z"/><path d="M8 8V5a4 4 0 0 1 8 0v3"/></svg></span>';
      return '<div class="citem">' + picture +
        '<div><div class="citem__t">' + escapeHTML(i.product_title) + '</div>' +
        '<div class="citem__v">' + escapeHTML(i.variant_title || '') + ' · Qty ' + i.quantity + '</div>' +
        '<button data-remove-line="' + escapeHTML(i.key) + '">Remove</button></div>' +
        '<div>' + money(i.final_line_price, cur) + '</div></div>';
    }).join('') : '<p style="padding:24px 0;color:var(--faint)">Your cart is empty.</p>';
    var tot = document.querySelector('[data-cart-total]'); if (tot) tot.textContent = money(cart.total_price, cur);
    // No free-shipping progress bar: shipping is free worldwide with no minimum, so the drawer
    // states it once and nothing recalculates it per cart (operator 2026-08-25).
    document.querySelectorAll('[data-cart-count]').forEach(function(count) { count.textContent = cart.item_count; });
    document.querySelectorAll('[data-open-cart][aria-label]').forEach(function(button) { button.setAttribute('aria-label','Cart (' + cart.item_count + ' items)'); });
    var checkout = drawer.querySelector('[data-checkout]'); checkout.hidden = !cart.item_count;
    var notice = drawer.querySelector('[data-cart-error]'); if (notice) notice.remove();
  }
  function refreshCart() { return window.IndiaLivingCart ? window.IndiaLivingCart.run() : fetch(root + 'cart.js').then(checked).then(renderCart); }
  function changeLine(key, qty) {
    if(window.IndiaLivingCart) return window.IndiaLivingCart.run(function(cart) { return window.IndiaLivingCart.change(cart,key,qty); });
    return fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty }) }).then(checked).then(renderCart);
  }

  // Product form → AJAX add → drawer. Falls back to normal submit without JS.
  document.querySelectorAll('form[data-product-form]').forEach(function (f) {
    f.addEventListener('submit', function (ev) {
      ev.preventDefault();
      var btn = f.querySelector('[type=submit]'); if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
      var add = function() { return fetch(root + 'cart/add.js', { method: 'POST', body: new FormData(f) })
        .then(function (r) { if (!r.ok) throw new Error('Could not add'); return r.json(); })
        .then(function () { return fetch(root + 'cart.js').then(checked); }); };
      (window.IndiaLivingCart ? window.IndiaLivingCart.run(add) : add().then(renderCart))
        .then(openDrawer)
        .catch(cartError)
        .finally(function () { if (btn) { btn.disabled = false; btn.textContent = 'Add to cart'; } });
    });
  });

  // Variant select → price + availability line, written by the section's JSON payload.
  document.querySelectorAll('[data-variant-select]').forEach(function (sel) {
    var data = {}; try { data = JSON.parse(sel.getAttribute('data-variants')); } catch (e) {}
        sel.addEventListener('change', function () {
      var v = data[sel.value]; if (!v) return;
      var p = document.querySelector('[data-price]'); if (p) p.textContent = v.price;
      var idInput = document.querySelector('input[name=id]'); if (idInput) idInput.value = sel.value;

    });
  });

  // Quantity steppers, filter panel, gallery thumbs
  document.addEventListener('click', function (ev) {
    var q = ev.target.closest('[data-qty]');
    if (q) { var input = q.parentElement.querySelector('input'); var n = parseInt(input.value || '1', 10) + parseInt(q.getAttribute('data-qty'), 10); input.value = Math.max(1, n); }
    if (ev.target.closest('[data-toggle-filters]')) { var p = document.querySelector('.fpanel'); if (p) p.classList.toggle('open'); }
    var th = ev.target.closest('[data-thumb]');
    if (th) { var hero = document.querySelector('[data-hero-img]'); if (hero) { hero.src = th.getAttribute('data-thumb'); hero.srcset = ''; } }
  });

  // Filter checkboxes auto-submit their form (native Shopify storefront filtering)
  document.querySelectorAll('form[data-filter-form] input[type=checkbox]').forEach(function (c) {
    c.addEventListener('change', function () { c.form.submit(); });
  });
})();
